import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-customer-card',
  templateUrl: './customer-card.component.html',
  styleUrls: ['./customer-card.component.css']
})
export class CustomerCardComponent {
  @Input() customer: any;
  @Input() filterTxt: string = '';
  @Input() hubspotintegration: boolean = false;
}

